import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js/mobile';

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  public transform(value: string, prefix: string): boolean {
    if (!value || !prefix) {
      return null;
    }

    try {
      const phoneNumber = parsePhoneNumber(prefix + value);
      const isValid = phoneNumber.isValid();
      const nrType = phoneNumber.getType();
      const isMobileNr = nrType === 'MOBILE' || nrType === 'FIXED_LINE_OR_MOBILE';
      return isValid && isMobileNr;
    } catch {
      return false;
    }
  }
}
